import React from 'react';
import { Button } from 'antd';
import cn from 'classnames';
import SaveDraft from '../SaveDraft/SaveDraft';
import styles from './ModalFooter.module.scss';

const ModalFooter = ({ form, onCancel, onSubmit, loading }) => (
  <div className={styles.root}>
    <SaveDraft
      form={form}
      onCancel={onCancel}
      disabled={loading}
    />
    <div className={styles.innerWrap}>
      <Button
        onClick={onCancel}
        disabled={loading}
      >
        Отмена
      </Button>
      <Button
        type="primary"
        onClick={onSubmit}
        loading={loading}
        className={cn({ [styles.submitBtnDisabled]: loading })}
      >
        Ок
      </Button>
    </div>
  </div>
);
export default ModalFooter;
